export class enquiry{
    Name:string;
    Email:string;
    Mobile:string;
    Message:string;
}